import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
export interface Crumb {
  label: string;
  /** Omitted on the final crumb, which is the current page. */
  to?: string;
}
interface BreadcrumbsProps {
  items: Crumb[];
  /** Rendered over a dark photograph rather than on a light surface. */
  onDark?: boolean;
}

/**
 * An ordered list, because the order carries meaning. The final crumb is
 * plain text with `aria-current="page"` — linking a page to itself gives a
 * keyboard user a stop that does nothing.
 *
 * Rendered only where there is a real ancestor to climb to; a single crumb
 * is navigation furniture with no destination.
 */
export function Breadcrumbs({
  items,
  onDark = false
}: BreadcrumbsProps) {
  if (items.length < 2) return null;
  const linkClass = onDark ? 'text-cream/75 hover:text-flame focus:ring-offset-ink-deep' : 'text-ink-muted hover:text-rust focus:ring-offset-cream';
  return <nav aria-label="Breadcrumb" data-id="element-395" data-mp="3o6k1qr6a6437">
      <ol className="flex flex-wrap items-center gap-x-1 gap-y-1 text-sm" data-id="element-396" data-mp="2u3c97cofhgvb">
        {items.map((crumb, index) => {
        const isLast = index === items.length - 1;
        return <li key={crumb.label} className="flex items-center" data-id="element-397" data-mp="334a517opqi2t" data-mpi={index}>
              {index > 0 && <ChevronRight aria-hidden="true" className={`mr-1 h-3.5 w-3.5 shrink-0 ${onDark ? 'text-cream-muted' : 'text-ink-muted'}`} data-id="element-398" data-mp="2y5p393ttbqc9" />}

              {isLast || !crumb.to ? <span aria-current="page" className={`font-bold ${onDark ? 'text-cream' : 'text-ink'}`} data-id="element-399" data-mp="2k5o0tjxwgauo">
                  {crumb.label}
                </span> : <Link to={crumb.to} className={`rounded-control px-0.5 py-1 font-medium underline decoration-transparent underline-offset-2 transition-colors duration-200 ease-out-expo hover:decoration-current focus:outline-none focus:ring-2 focus:ring-flame focus:ring-offset-2 ${linkClass}`} data-id="element-400" data-mp="1rolg4arwf8zd">
                  {crumb.label}
                </Link>}
            </li>;
      })}
      </ol>
    </nav>;
}